import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4h1.53L6.24 7.056l-.791-2.372A1 1 0 0 0 4.5 4H2v2h1.78l.339 1.018A3.75 3.75 0 1 0 7.425 11.5h1.15a3.751 3.751 0 1 0 3.958-4.49l-.873-3.495A2 2 0 0 0 9.72 2H8v2Zm-.927 5.01c.082.158.154.321.214.49h1.426a3.762 3.762 0 0 1 1.856-2.103l-.332-1.324L7.073 9.01ZM3.75 9c.122 0 .241.013.357.036l-.787.731A1 1 0 0 0 4 11.5h1.332A1.75 1.75 0 1 1 3.75 9Zm7.331.448a1.75 1.75 0 1 0 2.002-.237l.387 1.546-1.94.486-.449-1.795Z",
    fill: "currentColor"
  }));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Bike16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Bike16 = createIcon(IconComponent);